import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import axiosInstance from "../../axios";
import urls from "../../Utils/urls";

const StripePaymentForm = ({
  onSuccess,
  submitFlag,
  data,
  setSubmitLoading,
  paymentIntentId,
  clientSecret,
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);

  const handlePayment = async () => {
    if (!stripe || !elements) return;

    setSubmitLoading(true);
    setError(null);

    const { error: submitError } = await elements.submit();

    if (submitError) {
      setError(submitError.message);
      setSubmitLoading(false);
      return;
    }

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      clientSecret,
      confirmParams: {
        return_url: window.location.origin + "/payment-success",
      },
      redirect: "if_required",
    });
    // console.log({ stripe });
    // console.log({ paymentIntent });

    if (error) {
      setError(error.message);
      setSubmitLoading(false);
      return;
    }

    if (paymentIntent?.status === "succeeded") {
      // const headers = {
      //   "x-api-key": "12kXk3Xiou6Z50k0HSFZ5D8CScq2w6xJ",
      // };
      // const res2 = await axiosInstance.post(
      //   urls.VOM.VOMInvoiceAPI,
      //   {
      //     paymentIntentId: paymentIntent.id,
      //     invoiceId: invoiceID,
      //     // paymentIntentId: paymentIntentId,
      //   },
      //   { headers },
      // );
      // console.log(res2?.data);
      onSuccess(data, true);
    }
    // else {
    //   onSuccess(data, true);
    // }
  };

  useEffect(() => {
    if (submitFlag) {
      handlePayment();
    }
  }, [submitFlag]);

  return (
    <>
      <PaymentElement />

      {error && <p className="text-error small mt-2">{error}</p>}

      {/* <button
        type="button"
        className="btn btn-success btn-lg px-4 mt-4 w-100"
        onClick={handlePayment}
        disabled={loading || !stripe}
      >
        {loading ? "Processing..." : "Pay & Submit"}
      </button> */}
    </>
  );
};

export default StripePaymentForm;
